module.exports = __webpack_public_path__ + "media/images/icons/preventive_icon-62c995417a8b6e5a587b2be62517f33f.svg";